import { computed, toValue } from 'vue';
import { SPORT_LIVE_TV_STATUSES } from '@/sport-live-tv/constants';
import { arrangeSportLiveTvEvents, getSportLiveTvEventStatus, sortSportLiveTvEvents, uniqueSportLiveTvEvents } from '@/sport-live-tv/helpers';
import { useSportLiveTvOverview } from '@/sport-live-tv/composables/use-sport-live-tv-overview';
import { useSportLiveTvSelectionEvents } from '@/sport-live-tv/composables/use-sport-live-tv-selection-events';
import { useSportLiveTvTeams } from '@/sport-live-tv/composables/use-sport-live-tv-teams';

export const useSportLiveTvCatalog = ({ selection, status, sort }) => {
  const overview = useSportLiveTvOverview();
  const teams = useSportLiveTvTeams();
  const selectionEvents = useSportLiveTvSelectionEvents({ selection, status, sort });

  const rows = computed(() =>
    overview.categories.value.map((category) => ({ ...category, events: arrangeSportLiveTvEvents(category.events, toValue(status), toValue(sort)) })).filter(({ events }) => events.length > 0)
  );

  const featured = computed(() => arrangeSportLiveTvEvents(overview.popular.value, toValue(status), toValue(sort)));

  const live = computed(() => {
    if (toValue(status) === SPORT_LIVE_TV_STATUSES.upcoming) return [];

    const liveEvents = overview.categories.value.flatMap(({ events }) => events).filter((event) => getSportLiveTvEventStatus(event) === SPORT_LIVE_TV_STATUSES.live);

    return sortSportLiveTvEvents(uniqueSportLiveTvEvents(liveEvents), toValue(sort));
  });

  return {
    categories: overview.categories,
    teams,
    rows,
    featured,
    live,
    selectionEvents,
    isLoading: overview.isLoading,
    isError: overview.isError,
    refetch: overview.refetch,
  };
};
